<template>
  <div id="lemontreeFoor" class="foot_lemontree">
    CopyRight &copy; Lemontree 2021.All rights reserved.
  </div>
</template>

<script>
export default{
  name:'Footer'
}
</script>

<style scoped>
.foot_lemontree{position:absolute;bottom:0;left:0;right:0;padding:20px 24px;font-size:14px;line-height:16px;background-color:#f1f1f1;color:#888;text-align:center}

@media (prefers-color-scheme: dark) {
  .foot_lemontree{background-color:#212121}
}
</style>